import { mString } from 'lib/helpers/utility';

import Divider from 'components/shared/Divider/Divider';
import Typography from 'components/shared/Typography/Typography';

const LedgerRow = ({ label, amount, color = 'neutral-900', isTotal }) => (
  <div className="flex items-center justify-between gap-3">
    <Typography variant="label" weight={isTotal ? 'semibold' : 'medium'}>
      {label}
    </Typography>
    <Typography variant="label" weight={isTotal ? 'semibold' : 'medium'} size="large" color={color}>
      {mString(amount)}
    </Typography>
  </div>
);

const CostLedger = ({ totalCost, payments, discounts, taxesAndFees, amountDue, accentColor }) => (
  <>
    <LedgerRow label="Total cost" amount={totalCost} />
    {payments > 0 && (
      <>
        <Divider />
        <LedgerRow label="Payments" amount={-payments} color="purple-500" />
      </>
    )}
    {discounts > 0 && (
      <>
        <Divider />
        <LedgerRow label="Discounts" amount={-discounts} color="success-500" />
      </>
    )}
    {taxesAndFees > 0 && (
      <>
        <Divider />
        <LedgerRow label="Taxes and fees" amount={taxesAndFees} />
      </>
    )}
    <Divider />
    <LedgerRow label="You pay today" amount={amountDue} color={accentColor} isTotal />
  </>
);

export default CostLedger;
